import { render } from "./BidsListModal.vue?vue&type=template&id=21b28c10"
import script from "./BidsListModal.vue?vue&type=script&lang=js"
export * from "./BidsListModal.vue?vue&type=script&lang=js"

import "./BidsListModal.vue?vue&type=style&index=0&id=21b28c10&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__